import React from 'react';
import Link from '../../components/LinkWithCountry/LinkWithCountry';

const SecondaryPageEmpty = () => (
  <div data-part="secondary-state" role="status">
    <h2>This page is currently unavailable</h2>
    <p>Please try again later, or contact us for help.</p>
    <Link to="/contact">Contact us</Link>
  </div>
);

export default SecondaryPageEmpty;
